
import React from 'react';
import { Typography, Table, Tag } from 'antd';
import { AnalysisResult, AnalysisStatus } from '../../../types';

const { Text } = Typography;

interface MaintenanceRecommendationsProps {
  results: AnalysisResult;
  status: AnalysisStatus;
}

const MaintenanceRecommendations: React.FC<MaintenanceRecommendationsProps> = ({ results, status }) => {
  const { maintenance } = results;

  if (status === 'error') {
    return <Text>There was an unexpected error with maintenance recommendations, once the report is complete, please rerun the analysis.</Text>;
  } else if (status === 'skipped') {
    return <Text>Maintenance recommendations were skipped by the user.</Text>;
  }

  if (!maintenance) {
    return <Text>No maintenance data available.</Text>;
  }

  return (
    <div>

      {maintenance.recommended_maintenances && maintenance.recommended_maintenances.length > 0 ? (
        <Table
          dataSource={maintenance.recommended_maintenances}
          rowKey={(record, index) => `maintenance-${index}`}
          pagination={false}
          size="small"
          scroll={{ x: true }}
          style={{ marginTop: '16px' }}
        >
          <Table.Column
            title="Service Due"
            key="Service Due"
            render={(_, record: any) => {
              const text = record['Service Due'] || record['Service_Due'];
              if (!text) return null;
              return (
                <Tag color={text === 'ASAP' ? 'red' : text.includes('days') ? 'orange' : 'blue'}>
                  {text}
                </Tag>
              );
            }}
          />
          <Table.Column
            title="Area"
            key="Area"
            render={(_, record: any) => {
              const text = record['Area'] || record['Area'];
              return <Tag color="geekblue">{text}</Tag>;
            }}
          />
          <Table.Column
            title="Suggested Maintenance"
            key="Suggested Maintenance"
            render={(_, record: any) => {
              const text = record['Suggested Maintenance'] || record['Suggested_Maintenance'];
              return <Text strong>{text}</Text>;
            }}
          />
          <Table.Column
            title="Mileage"
            key="Mileage"
            render={(_, record: any) => {
              const text = record['Mileage'];
              return <Text type="secondary">{text?.toLocaleString()}</Text>;
            }}
          />
          <Table.Column
            title="Last Performed"
            key="Last Performed"
            render={(_, record: any) => {
              const text = record['Last Performed'] || record['Last_Performed'];
              return text && text !== 'Not on record' ? <Tag color="green">{text}</Tag> : null;
            }}
          />
          <Table.Column
            title="Cost Estimate"
            key="Maintenance Cost Estimate"
            render={(_, record: any) => {
              const text = record['Maintenance Cost Estimate'] || record['Maintenance_Cost_Estimate'];
              return <Text type="secondary">{text}</Text>;
            }}
          />
        </Table>
      ) : (
        <Text type="secondary">No maintenance items identified.</Text>
      )}
    </div>
  );
};

export default MaintenanceRecommendations;
